//Barber-Shop-Platform
import React from "react";
import Agent from "./agent.jsx";
export const isAuthenticated = () => {
  const token = localStorage.getItem("authToken");
  return token ? true : false;
};

// Function to log in the user (e.g., call an API and store the token)
export const loginUser = async (account) => {
  // Your API call to authenticate the user
  const { requests } = Agent();
  return await requests.publicPost("/auth/login", account);
};
